import type { ComponentProps } from 'react';
import { TextField } from './text-field';

type MoneyFieldProps = Omit<ComponentProps<typeof TextField>, 'type' | 'inputMode'>;

export function MoneyField(props: MoneyFieldProps) {
  return <TextField placeholder="€" {...props} inputMode="decimal" />;
}
